/**
 * 修复 iOS Safari 上 el-submenu 在折叠状态下点击无法弹出的 bug
 * 被 SidebarItem 引用，作用于每一个 el-submenu
 */
export default {
  mounted() {
    this.fixBugIniOS()
  },
  methods: {
    fixBugIniOS() {
      if (!this.$refs.subMenu) return

      const handleMouseleave = this.$refs.subMenu.handleMouseleave
      this.$refs.subMenu.handleMouseleave = (e) => {
        if (this.device === 'mobile') {
          return
        }
        handleMouseleave(e)
      }
    }
  }
}